/* tslint:disable */
/* eslint-disable */
/**
 * BS BFF(ダイナミックパッケージ/DP補助金申請) API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation
 */
export interface JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation {
    /**
     * 
     * @type {string}
     * @memberof JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation
     */
    catSmlClassNm?: string;
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationFromJSON(json: any): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation {
    return JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationFromJSONTyped(json, false);
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationFromJSONTyped(json: any, ignoreDiscriminator: boolean): JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'catSmlClassNm': !exists(json, 'catSmlClassNm') ? undefined : json['catSmlClassNm'],
    };
}

export function JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformationToJSON(value?: JpCoBenefitoneBsdpBffPresentationResponseFellowtravelersGetOrderConfirmResponseMenuBasicInfoCategoryInformation | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'catSmlClassNm': value.catSmlClassNm,
    };
}

